import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=b1f06eb8&scoped=true"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=b1f06eb8&prod&scoped=true&lang=scss"
import style1 from "./NewTemplate.vue?vue&type=style&index=1&id=b1f06eb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f06eb8",
  null
  
)

export default component.exports